import { RICH_TEXT_STYLE_COMPONENTS } from '@components/rich-text/rich-text-component-map';
import { PortableText } from '@portabletext/react';
import type { ReactElement } from 'react';
import React from 'react';
import type { RichText } from 'types/components/rich-text/rich-text';
import { validateString } from 'utils/validate-string';

import styles from './rich-text.module.scss';

interface RichtTextProps {
  readonly value: RichText | RichText[];
}

const rootClass = validateString(styles.root);

function RichTextComponent({ value }: RichtTextProps): ReactElement {
  return (
    <div className={rootClass}>
      <PortableText
        components={{
          block: RICH_TEXT_STYLE_COMPONENTS,
        }}
        value={value}
      />
    </div>
  );
}

export default RichTextComponent;
